export const promoteInstallmentsConfiguration = {
  minimumPrice: 4000,
  numberOfInstallments: 3,
}
